<template>
  <AppDialogContent
    v-if="video"
    v-model="visible"
    hide-actions
    max-width="860px"
  >
    <template #header>
      {{ video.title }}
    </template>

    <section class="d-flex" style="position: relative;min-height: 360px;">
      <div v-show="videoLoading" class="ma-auto align-center">
        <v-progress-circular :indeterminate="videoLoading" size="48" />
      </div>
      <div v-show="!videoLoading" ref="iframeWrapper" style="flex-grow: 1;">
        <div />
      </div>
    </section>
  </AppDialogContent>
</template>
<script>
import {
  defineComponent,
  computed,
  ref,
  watch,
  toRef,
  onBeforeUnmount
} from "vue";
import AppDialogContent from "./AppDialogContent.vue";
import i18next from "i18next";

export default defineComponent({
  name: "AppVideoDialog",
  components: {
    AppDialogContent
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    video: {
      type: Object,
      default: null
    }
  },
  setup(props, ctx) {
    const videoProp = toRef(props, "video");
    const lng = ref(i18next.language);
    function setLanguage(newLng) {
      lng.value = newLng;
    }
    i18next.on("languageChanged", setLanguage);
    onBeforeUnmount(() => {
      i18next.off("languageChanged", setLanguage);
    });

    let timeouter = null;

    const visible = computed({
      get() {
        return props.value;
      },
      set() {
        ctx.emit("hide");
        iframeWrapper.value.replaceWith(document.createElement("div"));
      }
    });

    const videoLoading = ref(false);

    const iframeWrapper = ref(null);

    watch(
      videoProp,
      async video => {
        clearTimeout(timeouter);
        if (video?.link) {
          try {
            videoLoading.value = true;
            let link = video.link;
            const response = await fetch(
              `https://vimeo.com/api/oembed.json?url=${link}&response=true&texttrack=${lng.value}`
            ).then(response => response.json());

            const iframe = document
              .createRange()
              .createContextualFragment(response.html);

            iframe.firstChild.setAttribute("width", "100%");
            iframe.firstChild.setAttribute("height", "100%");
            iframeWrapper.value.firstChild.replaceWith(iframe);
            // Give bit of delay for iframe to load up
            timeouter = setTimeout(() => {
              videoLoading.value = false;
            }, 1000);
          } catch (error) {
            console.error(error);
          }
        }
      },
      {
        deep: true,
        immediate: true
      }
    );

    return {
      videoLoading,
      visible,

      iframeWrapper
    };
  }
});
</script>
<style lang="scss" scoped>
iframe,
.loading-message {
  width: 100%;
  max-width: 100%;
  height: 530px;
  display: block;
}
iframe {
  border: 2px solid #2c2c2c;
  border-radius: 4px;
}
</style>
